
module dg.lists {

    export interface IGridListOptions extends IListOptions {
        uiGrid?: uiGrid.IGridOptions;
        useExternalSorting?: boolean;
        actionColumnEnabled?: boolean;
        autoResizeGrid?: boolean;
        useGridScroll?: boolean;
    }

    //export class GridListOptions implements IGridListOptions {

    //    public type: 'grid';
    //    public templateUrl: '/digmo/src/actions/list-query/list-query';
    //    public displayValue: 'View grid';
    //}

    export class GridListController {

        public constructor(
            private gridListConfigurationService: GridListConfigurationService,
            private $scope: ng.IScope,
            private uiGridConstants: uiGrid.IUiGridConstants,
            private $timeout: ng.ITimeoutService,
            private $window: ng.IWindowService,
            private $element: ng.IAugmentedJQuery,
            private listItemSelectedChannelService: ListItemSelectedChannelService
        ) {
            this.uiGridOptions = {};
            this.isGridInitialized = false;
            this.isLoaded = false;
            //this.disableScrolling();
        }

        public options: IGridListOptions;
        public uiGridOptions: uiGrid.IGridOptions;
        public isGridInitialized: boolean;
        public isLoaded: boolean;
        public queryManipulator: dg.actions.QueryManipulator;
        //public hasItems: boolean = false;

        public viewHeight: number;
        public totalGridHeight: number;

        public viewStyle = { height: '0px' };
        public gridStyle = { height: '0px' };


        private gridApi: uiGrid.IGridApiOf<any>;
        private meta: dg.restfulApi.DomainObjectMetadata;
        private sortFromGrid: boolean = false;

        private resizeBody = () => {
            this.viewHeight = dgUtils.UiService.recalculateViewHeight(this.$window.innerHeight);
            this.recalculateGridHeight();
            this.recalculateHeights();
        }

        $onInit = () => {
            this.viewHeight = dgUtils.UiService.recalculateViewHeight(this.$window.innerHeight);
            this.recalculateGridHeight();
            this.recalculateHeights();

            angular.element(this.$window).on('resize', this.resizeBody);

            //this.$scope.$on('$destroy', () => this.onDestroy());

            //this.queryManipulator.onResultLoadedFirstTime(this.initGrid);

            //this.queryManipulator.onResultChanged(this.reloadData);

            //this.queryManipulator.onStartExecutingQuery(this.startLoading);

        }

        $onChanges(changes) {
            if (changes.queryManipulator && changes.queryManipulator.currentValue) {
                this.queryManipulator.onResultLoadedFirstTime(this.reloadData);

                this.queryManipulator.onResultChanged(this.reloadData);

                this.queryManipulator.onStartExecutingQuery(this.startLoading);

            }
        }

        $onDestroy() {
            angular.element(this.$window).off('resize', this.resizeBody);
        }

        initGrid = () => {

            let opt = this.gridListConfigurationService.initMetaOptions(this.queryManipulator, this.options);
            this.uiGridOptions = dgUtils.ObjectHelperService.mergeDeep(this.uiGridOptions, opt);

            if (this.uiGridOptions.totalItems > 0) {

                this.uiGridOptions.onRegisterApi = (gridApi) => {
                    this.gridApi = gridApi;
                    //this.gridApi.pagination.on.paginationChanged(this.$scope, (currentPage, pageSize) => {
                    //    this.queryManipulator.changePage({
                    //        pageNumber: currentPage,
                    //        pageSize: pageSize
                    //    });
                    //});

                    this.gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns: Array<uiGrid.IGridColumn>) => {
                        if (this.uiGridOptions.enableSorting) {
                            this.sortFromGrid = true;
                            var sortColumn = sortColumns[0];

                            let newSortCriteria: domain.queries.SortCriterion;
                            if (sortColumn) {
                                newSortCriteria = {
                                    property: sortColumn.field,
                                    displayValue: sortColumn.displayName || sortColumn.field,
                                    direction: sortColumn.sort.direction
                                };

                            }
                            else {
                                newSortCriteria = {
                                    property: '',
                                    displayValue: '',
                                    direction: ''
                                };

                            }
                            this.queryManipulator.sort(newSortCriteria);
                        }


                    });

                    this.gridApi.core.on.rowsRendered(this.$scope, (grid) => {
                        if (!this.sortFromGrid) {
                            var sortCriteria = this.queryManipulator.sortCriteria;

                            if (sortCriteria && sortCriteria.property) {
                                this.gridApi.grid.columns.forEach((col) => {
                                    if (col.field.toLowerCase() === sortCriteria.property.toLowerCase()) {
                                        col.sort = {
                                            priority: 1,
                                            direction: sortCriteria.direction
                                        };
                                    } else {
                                        col.sort = {};
                                    }
                                });
                            }
                        }

                        this.sortFromGrid = false;
                        //For scroll
                        let gridElement = this.$element.find('.ui-grid-render-container-body').find('.ui-grid-viewport');

                        if (this.options.useGridScroll) {
                            gridElement.css('overflow-y', 'auto');
                        }
                        else {
                            gridElement.css('overflow-y', 'visible');

                            gridElement.css('height', '100%');
                            this.$element.find('.ui-grid').css('height', '100%');
                        }

                        //gridElement.css('overflow-x', 'scroll');


                        this.$timeout(() => {
                            if (this.queryManipulator.dataLoaded) {
                                this.isLoaded = true;
                            }
                        });
                    });

                    //Infinite Scroll http://ui-grid.info/docs/#/tutorial/212_infinite_scroll
                    //scope.gridApi.infiniteScroll.on.needLoadMoreData($scope, $scope.getDataDown);
                    //scope.gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, $scope.getDataUp);
                }

                //if (this.queryManipulator.pageable) {
                //    //   this.uiGridOptions.totalItems = result.totalCount;
                //    this.enablePagination(result.totalCount);
                //}
                this.isGridInitialized = true;

                this.recalculateGridHeight();
                this.recalculateHeights();
            }
            else {
                this.isLoaded = true;
            }

        }

        actionsDropdownAppendElement() {
            // If grid does not use scroll append to body, otherwise append to grid so that there is no doubled scroll
            if (!this.options.useGridScroll) {
                return angular.element(document).find('.ui-grid-contents-wrapper')[0];
            }
        }

        itemSelected = (item) => {
            this.listItemSelectedChannelService.itemSelected(item);
        }

        enablePagination(totalCount) {
            this.uiGridOptions.totalItems = totalCount;
            this.uiGridOptions.enablePagination = totalCount > this.queryManipulator.pagingOptions.pageSize;
            this.uiGridOptions.enablePaginationControls = this.uiGridOptions.enablePagination;
        }

        startLoading = () => {
            this.isLoaded = false;
        }

        reloadData = () => {


            this.uiGridOptions.paginationCurrentPage = this.queryManipulator.pageNumber;

            if (!this.isGridInitialized) {
                this.initGrid();
            }

            let result = <dg.domain.queries.ListQueryResult<any>>this.queryManipulator.result;

            this.uiGridOptions.data = result.items;
            this.uiGridOptions.virtualizationThreshold = result.items.length;

            this.$timeout(() => {
                if (result.totalCount == 0) {
                    this.isLoaded = true;
                }
            });

            //this.enablePagination(result.totalCount);


            this.viewHeight = dgUtils.UiService.recalculateViewHeight(this.$window.innerHeight);
            this.recalculateGridHeight();
            this.recalculateHeights();
        }

        recalculateHeights() {
            let gridHeight = this.totalGridHeight;
            if (this.viewHeight < gridHeight) {
                gridHeight = this.viewHeight - 5;
            }

            this.gridStyle.height = gridHeight + 'px';
            this.$element.find('.ui-grid-render-container-body .ui-grid-viewport').height(gridHeight - 30);
            this.viewStyle.height = this.viewHeight + 'px';
        }

        recalculateGridHeight() {
            let rowHeight = 30;//this.uiGridOptions.rowHeight; 
            let headerHeight = 30; //this.uiGridOptions.rowHeight;
            let pagingHeight = this.uiGridOptions.enablePagination ? 33 : 2;
            let gridHeight = 0;
            if (this.uiGridOptions.data) {

                gridHeight = this.uiGridOptions.data.length * rowHeight + headerHeight + pagingHeight;
            }

            this.totalGridHeight = gridHeight;
        }

        //recalculateViewHeight = () => {

        //    let topAndBottomElementsHeight = angular.element('.navbar-header').first().outerHeight(true)
        //        + angular.element('.page-heading').first().outerHeight(true)
        //        + angular.element('.app-footer').first().outerHeight(true);
        //    let windowHeight = $(window).height();

        //    this.viewHeight = this.$window.innerHeight - topAndBottomElementsHeight - 5;
        //}


        //$onChanges = (changesObj) => {
        //    if (this.isGridInitialized && changesObj.listResult.currentValue) {

        //        var sortCriteria = this.queryManipulator.getSortCriteria();
        //        if (!this.sortFromGrid && this.gridApi) {
        //            this.gridApi.grid.columns.forEach((col) => {
        //                if (col.field === sortCriteria.fieldId) {
        //                    col.sort = {
        //                        priority: 1,
        //                        direction: sortCriteria.isAscending ? this.uiGridConstants.ASC : this.uiGridConstants.DESC
        //                    };
        //                } else {
        //                    col.sort = {};
        //                }
        //            });
        //        }
        //        this.sortFromGrid = false;

        //        this.uiGridOptions.data = changesObj.listResult.currentValue.items;
        //    }
        //};
    }



    angular.module('dg.lists').component('gridList', {
        bindings: {
            options: '<',
            queryManipulator: '<'
        },
        controller: GridListController,
        templateUrl: '/digmo/src/lists/grid-list/grid-list.html'
    });
}